/** Main project script */
'use strict';


import * as Vue from 'vue';
import {createApp} from 'vue';

import useCollapse from "./composables/collapser";
import CarouselHolder from './components/carousel-holder';
import CardCarousel from './components/card-carousel';
import SuggestiveSearch from './components/suggestive-search';
import MapBox from './components/map-box';
import TeamMembers from './components/team-members.vue';
import GoogleReviews from './components/google-reviews.vue';

import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css';


import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client/core';

var link = window.solout.baseUrl.split('/');
link.push('graphql');
link = link.filter(function (el) {
    if (el === null || el === undefined || el === "" || !el || el === " ") {
        return false;
    }
    return true;
});

link = '/' + link.join('/');

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: link,
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

import {createApolloProvider} from '@vue/apollo-option'

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})

//  end graphql
const toggleLightbox = (index) => {
    indexRef.value = index
    visibleRef.value = true
}

const app = createApp({
    components: {
        CarouselHolder,
        CardCarousel,
        SuggestiveSearch,
        MapBox,
        VueEasyLightbox,
        TeamMembers,
        GoogleReviews
    },
    setup () {
        useCollapse();
    },
    // Shared app state
    data() {
        return {
            navigation: {
                open: false,
                openSubMenu: 0,
                mobileMenuOpen: false,
                mobileMenuSubMenu: 0,
                searchBarOpen: false
            },
            minPageHeight: null,
            scrolled: false,
            lightboxVisibleRef: false,
            lightboxIndexRef: 0
        };
    },
    methods: {
        handleScroll: function () {
            if (window.scrollY > 44) {
                // The screen is scrolled down more than 44 pixels from the top
                this.scrolled = true;
            } else {
                // The screen is at the top or close to it
                this.scrolled = false;
            }
        },
        fixSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.searchBarOpen = true;
            } else {
                this.navigation.searchBarOpen = false;
            }
        },
        toggleSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.searchBarOpen = !this.navigation.searchBarOpen;
        },
        toggleSubmenu: function (id) {

            if (this.navigation.openSubMenu === id) {
                this.navigation.openSubMenu = 0;
            } else {
                this.navigation.openSubMenu = id;
            }
        },
        handleMenuClick: function (event, id, hasChildren) {
            // Check if touch device
            const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

            if (isTouchDevice && hasChildren) {
                // If dropdown is already open for this item, allow navigation
                if (this.navigation.openSubMenu === id) {
                    return true; // Allow default navigation
                }
                // Otherwise, open dropdown and prevent navigation
                event.preventDefault();
                this.navigation.openSubMenu = id;
                return false;
            }
            // Non-touch device: allow normal navigation (hover handles dropdown)
            return true;
        },
        closeSubMenu: function () {
            this.navigation.openSubMenu = 0;
        },
        fixMobileMenu: function (action) {
            if (action === 'open') {
                this.navigation.mobileMenuOpen = true;
            } else {
                this.navigation.mobileMenuOpen = false;
            }
        },
        toggleMobileMenu: function (id) {
            this.navigation.searchBarOpen = false;
            this.navigation.mobileMenuOpen = !this.navigation.mobileMenuOpen;
        },
        toggleMobileSubmenu: function (id) {
            if (this.navigation.mobileMenuSubMenu === id) {
                this.navigation.mobileMenuSubMenu = 0;
            } else {
                this.navigation.mobileMenuSubMenu = id;
            }
        },
        toggleLightbox: function (index) {
            this.lightboxIndexRef = index;
            this.lightboxVisibleRef = true;
        },
        toggleTeamMemberLightbox: function (id) {
            // do something
        },
        goTo: function (url, newTab) {
            if (!url) {
                return false;
            }
            newTab = newTab || false;
            if (newTab) {
                return window.open(url);
            }
            return window.location.href = url;
        },
        setupScrollHelper: function () {
            let targets = document.querySelectorAll('[data-scrollhelper]');
            // loop through the targets
            const options = {
                root: null,
                threshold: 0.2
            };

            for (let i = 0; i < targets.length; i++) {
                let preset = targets[i].dataset?.presetClass?.trim().split(' ');
                let parent = targets[i].closest('section');
                parent.classList.add('animation-parent');
                if (preset) {
                    preset.forEach(value => targets[i].classList.add(value));
                    // targets[0].classList.add(preset.join[',']);
                }
            }

            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // process:
                        let me = entry.target;

                        let cssClass = me.dataset?.class?.trim().split(' ');

                        if (cssClass) {
                            cssClass.forEach(value => me.classList.add(value));
                            // me.classList.add(cssClass);
                        }

                        me.classList.add("appear-on-scroll");
                        observer.unobserve(me);
                    } else {
                        return;
                    }
                });
            }, options);

            targets.forEach(target => observer.observe(target));

        },
        scrollHelper: function (el, elClass, offset, callback) {
        },
        toggleParentClass: function (parentSelector, className, method) {
            if (method === 'add') {
                document.querySelector(parentSelector).classList.add(className);
            } else {
                document.querySelector(parentSelector).classList.remove(className);
            }
        },


    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll;
        // this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        // window.addEventListener('scroll', this.handleScroll);

    },
    mounted() {
        this.setupScrollHelper();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

app.config.globalProperties.location = window.location;
app.use(apolloProvider);
app.mount('#tw_app');

// Medmate Telehealth Widget
(function() {
    // Brand color - Medmate requires hex format
    var colorDark = "#2578BD";

    // Location IDs
    var LOCATION_PRODUCTION = "6037";
    var LOCATION_TEST = "5337";

    // Widget configurations: [selector, telehealth-class, isTest]
    var widgetConfigs = [
        // Production widgets (location 6037)
        [".widget-appointment", "Telehealth-Symptom-Request", false],
        [".widget-certificate", "Telehealth-Medical-Certificate-Request", false],
        [".widget-prescription", "Telehealth-Prescription-Request", false],
        // Test widgets (location 5337)
        [".widget-appointment-test", "Telehealth-Symptom-Request", true],
        [".widget-certificate-test", "Telehealth-Medical-Certificate-Request", true],
        [".widget-prescription-test", "Telehealth-Prescription-Request", true]
    ];

    // Generate UUID (with fallback for older browsers)
    function generateUUID() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        }
        // Fallback for older browsers
        return Date.now().toString(36) + '-' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Generate or retrieve unique user ID for this session
    function getUserUID() {
        var uid = sessionStorage.getItem('medmate_uid');
        if (!uid) {
            uid = generateUUID();
            sessionStorage.setItem('medmate_uid', uid);
        }
        return uid;
    }

    // Append UID to URL without page reload
    function appendUIDToURL(uid) {
        var url = new URL(window.location);
        if (!url.searchParams.has('id')) {
            url.searchParams.set('id', uid);
            window.history.replaceState({}, '', url);
        }
    }

    function initWidget() {
        var foundWidget = false;

        widgetConfigs.forEach(function(config) {
            var selector = config[0];
            var telehealthClass = config[1];
            var isTest = config[2];
            var target = document.querySelector(selector);

            if (target && !target.querySelector('#medmate-telehealth')) {
                var locationId = isTest ? LOCATION_TEST : LOCATION_PRODUCTION;
                var html =
                    '<div id="medmate-telehealth" ' +
                    'data-enable-use-app-popup="0" ' +
                    'data-telehealth-class="' + telehealthClass + '" ' +
                    'data-location-id="' + locationId + '" ' +
                    'data-payment-method="Telehealth Online" ' +
                    'data-surrounding-elements="[]" ' +
                    'data-source="Telehealth-' + locationId + '-Request" ' +
                    'data-button-color="' + colorDark + '" ' +
                    'data-main-color="' + colorDark + '" ' +
                    'data-secondary-color="' + colorDark + '" ' +
                    'data-dark-color="' + colorDark + '" ' +
                    'data-tile-color="' + colorDark + '" ' +
                    'data-show-header="0"></div>';

                target.innerHTML = html;
                foundWidget = true;
            } else if (target && target.querySelector('#medmate-telehealth')) {
                foundWidget = true;
            }
        });

        if (!foundWidget) return;

        // Add unique user ID to URL for tracking
        var userUID = getUserUID();
        appendUIDToURL(userUID);

        // Load Medmate script if not already loaded
        if (!document.querySelector('script[src*="medmate.com.au"]')) {
            var s = document.createElement("script");
            s.src = "https://app.medmate.com.au/connect/js/telehealth.js?v=2025-11-12_11";
            s.async = true;
            document.body.appendChild(s);
        }
    }

    // Hide banner when widget navigates to form steps (hash has path segments)
    var lastHash = window.location.hash;

    function checkBannerVisibility() {
        var hash = window.location.hash;
        var banner = document.querySelector('.element-banner');
        if (!banner) return;

        // Only hide banner on mobile/tablet (below 1024px)
        var isMobile = window.innerWidth < 1024;

        // If hash has path like #/telehealth-form/something, hide banner and scroll to widget
        if (isMobile && hash && hash.split('/').filter(Boolean).length >= 2) {
            banner.style.display = 'none';
            document.body.classList.add('medmate-form-active');

            // Scroll to the Medmate widget element with offset
            var widget = document.querySelector('.element.app__elements__medmatewidget');
            if (widget) {
                var offsetTop = widget.getBoundingClientRect().top + window.pageYOffset - 80;
                window.scrollTo({ top: offsetTop, behavior: 'smooth' });
            }
        } else {
            banner.style.display = '';
            document.body.classList.remove('medmate-form-active');
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWidget);
    } else {
        initWidget();
    }

    // Smooth scroll for anchor links pointing to elements on the same page
    document.addEventListener('click', function(e) {
        var link = e.target.closest('a[href*="#"]');
        if (!link) return;

        var href = link.getAttribute('href');
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;

        var hash = href.substring(hashIndex);
        var beforeHash = href.substring(0, hashIndex);

        // Check if link is to the same page (empty path, same path, or same origin+path)
        var currentPath = window.location.pathname;
        var isSamePage = !beforeHash ||
            beforeHash === currentPath ||
            beforeHash === window.location.origin + currentPath ||
            beforeHash === window.location.href.split('#')[0];

        if (isSamePage && hash.length > 1) {
            var targetId = hash.substring(1);
            var target = document.getElementById(targetId);

            if (target) {
                e.preventDefault();
                var offsetTop = target.getBoundingClientRect().top + window.pageYOffset - 250;
                window.scrollTo({ top: offsetTop, behavior: 'smooth' });
                // Don't update URL - keep UID and other query params intact
            }
        }
    });

    // Listen for hashchange (direct hash changes)
    window.addEventListener('hashchange', checkBannerVisibility);

    // Listen for popstate (browser back/forward navigation)
    window.addEventListener('popstate', checkBannerVisibility);

    // Poll for hash changes (handles pushState/replaceState from external widget)
    setInterval(function() {
        if (window.location.hash !== lastHash) {
            lastHash = window.location.hash;
            checkBannerVisibility();
        }
    }, 100);

    checkBannerVisibility();

    // Hide previous .element sibling when clicking on widget tile-container
    document.addEventListener('click', function(e) {
        var clickedElement = e.target.closest('.tile-container');
        if (!clickedElement) return;

        // Find the widget element containing this tile (supports both medmatewidget and widget-* classes)
        var widgetElement = clickedElement.closest('.element[class*="widget-"], .element.app__elements__medmatewidget');
        if (!widgetElement) return;

        // Find and hide the previous sibling content or heading element
        var prevElement = widgetElement.previousElementSibling;
        while (prevElement) {
            if (prevElement.classList.contains('app__elements__content') || prevElement.classList.contains('app__elements__heading')) {
                prevElement.style.display = 'none';
                break;
            }
            prevElement = prevElement.previousElementSibling;
        }
    });
})();
